"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FlaskIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.827 12.219l-3.213-7.138V3h.773c.499 0 .914-.51.914-1.041 0-.532-.406-.959-.914-.959H4.62c-.5 0-.914.427-.914.959C3.707 2.49 4.112 3 4.62 3h.782v2.081l-1.941 4.31v.018L2.18 12.22a2.086 2.086 0 00-.085 1.471c.16.494.49.883.933 1.11.255.134.528.2.801.2h8.34a1.804 1.804 0 001.555-.92 2.054 2.054 0 00.094-1.87l.01.009zM6.034 8.166l1.112-2.458a.99.99 0 00.085-.408V3h1.564v2.3c0 .142.028.275.085.408l1.112 2.458H6.034z"
  })))
});
FlaskIcon.displayName = 'FlaskIcon';
var _default = exports.default = FlaskIcon;